module.exports = __webpack_public_path__ + "img/sld_abt_check_disable.6553858d.svg";